import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadProcessHistory } from 'store/actions/abox/processActions';
import { bind } from 'app/utils/decorators/decoratorUtils';

import Changelog from 'app/components/organisms/Changelog/Changelog';

class ProcessHistoryTab extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        isLoading: PropTypes.bool,
        records: PropTypes.arrayOf(PropTypes.object),
        startIndex: PropTypes.number,
        totalRecords: PropTypes.number,
        type: PropTypes.string.isRequired,
    };

    @bind
    loadData({ id, ...options }) {
        return this.props.loadProcessHistory(id, options);
    }

    render() {
        const { id, isLoading, records, startIndex, totalRecords, type } = this.props;
        return (
            <Changelog
                type={type}
                id={id}
                isLoading={isLoading}
                startIndex={startIndex}
                records={records}
                loadData={this.loadData}
                totalRecords={totalRecords}
            />
        );
    }
}

export default connect(
    state => ({
        records: state.abox.process.history.records,
        totalRecords: state.abox.process.history.count,
        isLoading: state.abox.process.history.isLoading,
        startIndex: state.abox.process.history.startIndex,
    }),
    { loadProcessHistory }
)(ProcessHistoryTab);
